import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import Dialog from "../../components/Dialog";
import { StyledFlexDiv } from "../../styles/MainStyles";
import ModalReportStyles from "../../styles/pages/Summaries/ModalReportStyles";
import ButtonStyles from "../../styles/components/ButtonStyles";
import { IconDelete, IconEdit, AddIcon } from "../../components/Icons";
import ModalCallback from "../../model/ModalCallback";
import ReportService from "../../service/Docente/ReportService";
import DialogMessage from "../../components/DialogMessage";
import GenericUtils from "../../utils/GenericUtils";
import DialogMessageProps from "../../model/DialogMessageProps";
import { TypeDialogMessageEnum } from "../../model/Enums/TypeDialogMessageEnum";
import {
    getEnumReportNumberValue,
    getEnumListReportNumberValues,
    getEnumProcessStringValue,
} from "../../model/Enums/TypeReport";
import ModalSelectData from "./ModalSelectData";
import {
    ListAndStringItem,
    ReportData,
    ReportItem,
    UpdatedParameters,
} from "../../model/Report";

const { BtnPrimary, DefaultButtonLink } = ButtonStyles;

const {
    StyledModalTitle,
    StyledModalSubTitle,
    StyledModalText,
    StyledModalAction,
    StyledGridDiv,
    StyledContainerBtns,
    StyledIconModalButton,
    StyledSelect,
    StyledOption,
} = ModalReportStyles;

export type WordChoosen =
    | "Campus"
    | "Curso"
    | "Escola"
    | "Modalidade"
    | "Professor"
    | "Atividade"
    | "Motivo Abono"
    | "Coordenador"
    | "Ação Realizada"
    | "Status Workflow"
    | "Status Plano"
    | "Status Agenda"
    | "Status Abono"
    | "Aula Associada"
    | "Carta Orientação"
    | "Status Aluno"
    | "Status TACH"
    | "Referência Início"
    | "Referência Fim";

export interface IModalReport {
    open: boolean;
    onClose?: (callback?: ModalCallback) => void;
    visibility?: boolean;
    dataReport: Required<ReportData>;
}

const ModalGenerateReport: React.FC<IModalReport> = ({
    open,
    onClose,
    visibility,
    dataReport,
}) => {
    const { instance } = useMsal();
    const [word, setWord] = useState<any>();
    const [dataToEdit, setDataToEdit] = useState<any>();
    const [success, setSuccess] = useState(false);
    const [singleDate, setSingleDate] = useState(false);
    const [editReport, setEditReport] = useState(false);
    const [dateRequired, setDateRequired] = useState(false);
    const [reportGradeHoraria, setReportGradeHoraria] = useState(false);
    const [studentReport, setStudentReport] = useState(false);
    const [openModalSelectData, setOpenModalSelectData] = useState(false);
    const [showDialog, setShowDialog] = useState(visibility ?? true);
    const [dialogMessageProps, setDialogMessageProps] =
        useState<DialogMessageProps>({} as DialogMessageProps);
    const [typeDataEdit, setTypeEditData] = useState("");
    const parameters = dataReport.parametros || [];
    const titleItem = dataReport.nome || "";
    const idReport = dataReport.id || "";
    const referencia = "Referência";

    const titleActivityProfessor =
        "Relatório Associação Atividades x Professor";
    const titleProfCoordinator = "Relatório Associação Professor x Coordenador";
    const titleReportPermission = "Relatório Gerenciar Permissões Usuários";
    const activityStudent = "Relatório Gestão de Atividades Estudantes";
    const logGenerateTach = "Relatório Log Gerar TACH";

    const gradeHoraria = "Relatório Grade Horária";
    const extratoMensal = "Relatório Extrato Mensal Horas";
    const successMessage =
        "Sua requisição está sendo processada. Verifique seu email docente para visualizar o relatório solicitado.";

    const updatedReportItems = parameters
        .filter((item) => item.nome !== "Referência Fim")
        .map((item) => {
            if (item.nome === "Referência Início") {
                return {
                    ...item,
                    nome: referencia,
                    isSelected: false,
                    reportItems: "",
                };
            }
            if (item.nome === "Status TACH") {
                return {
                    ...item,
                    nome: "Status Processo TACH",
                    isSelected: false,
                    reportItems: "",
                };
            }
            if (item.nome === "Status Plano") {
                return {
                    ...item,
                    nome: "Status TACH",
                    isSelected: false,
                    reportItems: "",
                };
            }
            if (titleItem === logGenerateTach && item.nome === "Professor") {
                return {
                    ...item,
                    nome: "Usuário",
                    isSelected: false,
                    reportItems: "",
                };
            }
            return { ...item, isSelected: false, reportItems: [] };
        });

    const listUpdatedItems: Record<string, number> = {
        Campus: 1,
        Escola: 2,
        Curso: 3,
        Modalidade: 4,
        Professor: 5,
        Usuário: 6,
        Atividade: 7,
        Referência: 8,
        Coordenador: 9,
        "Motivo Abono": 10,
        "Status Abono": 11,
        "Status Workflow": 12,
        "Status TACH": 13,
        "Ação Realizada": 14,
        "Aula Associada": 15,
        "Status Agenda": 16,
        "Status Aluno": 17,
        "Carta Orientação": 18,
        "Status Processo TACH": 19,
    };

    const compareList = (a: any, b: any) => {
        const wordA = listUpdatedItems[a.nome];
        const wordB = listUpdatedItems[b.nome];

        if (wordA === undefined && wordB === undefined) return 0;
        if (wordA === undefined) return 1;
        if (wordB === undefined) return -1;
        return wordA - wordB;
    };

    const newReportItems = updatedReportItems.sort(compareList);

    const [objectReportItems, setObjectReportItems] =
        useState<UpdatedParameters[]>(newReportItems);

    useEffect(() => {
        if (titleItem === gradeHoraria) {
            setSingleDate(true);
            setReportGradeHoraria(true);
        }
        if (titleItem === extratoMensal) {
            setSingleDate(true);
        }
        if (titleItem === activityStudent) {
            setStudentReport(true);
        }
    });

    const [state, setState] = useState({
        reportName: titleItem,
        resultCenterCampus: [],
        resultCenterNames: [],
        resultCenterSchools: [],
        resultCenterActivityModalities: [],
        teacherIds: [],
        activityNames: [],
        coordinatorIds: [],
        currentScheduleStatus: null,
        associatedClass: null,
        guidanceLetter: null,
        studentStatus: null,
        initialDate: "",
        finalDate: "",
        reason: [],
        actionTaken: [],
        allowanceStatus: [],
        statusOvertimeWorkflow: [],
        currentStatusActivityPlan: [],
        tachStatus: [],
    });

    const filterData = (item: ReportItem[], id: number) => {
        const allItems = item.filter((i: ReportItem) => i.checkAll);

        if (!item.length || allItems.length === item.length) return null;

        const param = id === 3 || id === 6 || id === 7 ? "name" : "codeId";

        return item
            .filter((i: ReportItem) => i.add)
            .map((i: ReportItem) => i[param]);
    };

    const setStateDate = (date: string): string => {
        const breakDate = date.split("/");
        const day = breakDate[0];
        const month = breakDate[1];
        const year = breakDate[2];

        return `${year}-${month}-${day}`;
    };

    const handleCloseDialogMessage = () => {
        setDialogMessageProps({} as DialogMessageProps);
        onClose?.();
    };

    const typeDialogMessage = (typeIcon: any) => {
        return success ? TypeDialogMessageEnum.Success : typeIcon;
    };

    const textMessage = (message: any) => {
        if (success) {
            return successMessage;
        }

        return message && message.length
            ? message
            : "Ocorreu um erro ao processar sua solicitação. Verifique se todos os campos estão preenchidos corretamente e tente novamente. Se o problema persistir, entre em contato com o administrador do sistema.";
    };

    const dialogMessage = dialogMessageProps.show && (
        <DialogMessage
            type={typeDialogMessage(dialogMessageProps.type)}
            show={dialogMessageProps.show}
            title={dialogMessageProps.title}
            text={textMessage(dialogMessageProps.text)}
            onClose={dialogMessageProps.onClose}
        />
    );

    const selectedItem = (
        param: unknown[],
        getValue: (...params: any[]) => any | null
    ) => {
        return param.length > 0 ? getValue(param) : null;
    };

    const handlePostValues = (nome: WordChoosen) => {
        const parametros = {
            Campus: filterData(state.resultCenterCampus, 1),
            Curso: filterData(state.resultCenterNames, 2),
            Escola: filterData(state.resultCenterSchools, 3),
            Modalidade: filterData(state.resultCenterActivityModalities, 4),
            Professor: filterData(state.teacherIds, 5),
            Atividade: filterData(state.activityNames, 6),
            "Motivo Abono": filterData(state.reason, 7),
            Coordenador: filterData(state.coordinatorIds, 8),
            // parametro Status TACH
            "Status Plano": selectedItem(
                state.currentStatusActivityPlan,
                getEnumListReportNumberValues
            ),
            "Status Abono": selectedItem(
                state.allowanceStatus,
                getEnumReportNumberValue
            ),
            "Ação Realizada": selectedItem(
                state.actionTaken,
                getEnumProcessStringValue
            ),
            "Status Workflow": selectedItem(
                state.statusOvertimeWorkflow,
                getEnumProcessStringValue
            ),
            // parametro Status Processo TACH
            "Status TACH": selectedItem(
                state.tachStatus,
                getEnumProcessStringValue
            ),
            "Status Agenda": state.currentScheduleStatus,
            "Aula Associada": state.associatedClass,
            "Carta Orientação": state.guidanceLetter,
            "Status Aluno": state.studentStatus,
            "Referência Início": setStateDate(state.initialDate),
            "Referência Fim": setStateDate(state.finalDate),
        };
        return parametros[nome] ?? null;
    };

    const handleSubmit = async () => {
        const postData = parameters.reduce((acc: any[], item: any) => {
            const value = handlePostValues(item.nome);
            if (value !== null) {
                acc.push({
                    key: {
                        id: item.id,
                    },
                    value: {
                        type: item.tipo,
                        value,
                    },
                });
            }
            return acc;
        }, []);

        const filteredItem = {
            nome: titleItem,
            relatorio: {
                id: idReport,
            },
            parametros: postData,
        };

        const response: any = await ReportService.postReport(
            instance,
            filteredItem
        );

        if (GenericUtils.isSuccessStatus(response)) {
            setSuccess(true);
        }

        const dialog = {
            ...GenericUtils.getPropsDialogError(response),
            onClose: handleCloseDialogMessage,
        };
        setShowDialog(false);
        setDialogMessageProps(dialog);
    };

    const handleOpenModalSelectData = (info: string, index: number) => {
        setOpenModalSelectData(true);
        setWord(info);
        setShowDialog(false);
        setObjectReportItems((prevState: any) => {
            const updatedItems = [...prevState];
            if (updatedItems[index].reportItems.length > 0) {
                updatedItems[index].isSelected = true;
            }
            return updatedItems;
        });
        setEditReport(false);
    };

    const handleCloseModalSelectData = () => {
        setOpenModalSelectData(false);
        setShowDialog(visibility ?? true);
    };

    const handleEditItems = (item: any, index: number, type: string) => {
        setShowDialog(false);
        setEditReport(true);
        setOpenModalSelectData(true);
        setObjectReportItems((prevState: any) => {
            const updatedItems = [...prevState];
            if (updatedItems[index].reportItems.length > 0) {
                updatedItems[index].isSelected = true;
            }
            return updatedItems;
        });

        if (type === "LIST") {
            setTypeEditData("list");
        }
        if (type === "STRING") {
            setTypeEditData("string");
        }
        setWord(item.nome);
        setDataToEdit(item.reportItems);
        if (type === "DATE") {
            setTypeEditData("date");
            const dates = [state.initialDate, state.finalDate];
            if (titleItem === extratoMensal) {
                setSingleDate(true);
            }
            if (titleItem === gradeHoraria) {
                setSingleDate(true);
                setReportGradeHoraria(true);
            }

            setDataToEdit(dates);
        }
    };

    const getUpdateInfo = (items: ReportItem[], value: string) => {
        const updatedItems = objectReportItems.map((data: any) => {
            if (data.nome === value) {
                const isSelected = items.some(
                    (item: ReportItem) => item.add === true
                );
                return {
                    ...data,
                    isSelected,
                    reportItems: items,
                };
            }
            return data;
        });
        setObjectReportItems(updatedItems);
    };

    const handleItemsUpdate = (items: ReportItem[]) => {
        const key = word as ListAndStringItem;

        const updateItem = {
            Atividade: "activityNames",
            Coordenador: "coordinatorIds",
            Professor: "teacherIds",
            Usuário: "teacherIds",
            Campus: "resultCenterCampus",
            Escola: "resultCenterSchools",
            Curso: "resultCenterNames",
            Modalidade: "resultCenterActivityModalities",
            "Motivo Abono": "reason",
            "Ação Realizada": "actionTaken",
            "Status Workflow": "statusOvertimeWorkflow",
            "Status TACH": "currentStatusActivityPlan",
            "Status Abono": "allowanceStatus",
            "Status Processo TACH": "tachStatus",
        };

        setState((prevState) => ({
            ...prevState,
            [updateItem[key]]: items,
        }));
        getUpdateInfo(items, word);
    };

    const handleDeleteItems = (item: any, index: number) => {
        const key = item.nome as ListAndStringItem;
        setObjectReportItems((prevState: any) => {
            const deleteIcon = [...prevState];
            deleteIcon[index].isSelected = false;
            return deleteIcon;
        });

        const deleteItem = {
            Atividade: "activityNames",
            Coordenador: "coordinatorIds",
            Professor: "teacherIds",
            Usuário: "teacherIds",
            Campus: "resultCenterCampus",
            Escola: "resultCenterSchools",
            Curso: "resultCenterNames",
            Modalidade: "resultCenterActivityModalities",
            "Motivo Abono": "reason",
            "Ação Realizada": "actionTaken",
            "Status Workflow": "statusOvertimeWorkflow",
            "Status TACH": "currentStatusActivityPlan",
            "Status Abono": "allowanceStatus",
            "Status Processo TACH": "tachStatus",
        };

        if (item.nome === referencia) {
            setState({ ...state, initialDate: "", finalDate: "" });
            setDateRequired(false);
        }

        setState({
            ...state,
            [deleteItem[key]]: [],
        });
    };

    const getUpdateDateInfo = (value: string) => {
        const updatedItems: UpdatedParameters[] = objectReportItems.map(
            (data: UpdatedParameters) => {
                if (data.nome === value)
                    return {
                        ...data,
                        isSelected: true,
                    };
                return data;
            }
        );
        setObjectReportItems(updatedItems);
        return updatedItems;
    };

    const handleDateItems = (initial: string, final: string) => {
        setState((prevState) => ({
            ...prevState,
            initialDate: initial,
            finalDate: final,
        }));
        getUpdateDateInfo(referencia);
        setDateRequired(true);
    };

    const handleSelectChange = (item: string, selectedValue: string) => {
        let key: string;
        let value: boolean | null;
        if (item === "Aula Associada") key = "associatedClass";
        if (item === "Status Agenda") key = "currentScheduleStatus";
        if (item === "Status Aluno") key = "studentStatus";
        if (item === "Carta Orientação") key = "guidanceLetter";

        if (selectedValue === "Selecione:") {
            value = null;
        } else {
            value = selectedValue === "Sim" || selectedValue === "Ativo";
        }

        setState((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };

    const editData = (
        <ModalSelectData
            open={openModalSelectData}
            data={word}
            onClose={handleCloseModalSelectData}
            arrItems={handleItemsUpdate}
            dateItem={handleDateItems}
            verifyDate={singleDate}
            editItems={editReport}
            editData={dataToEdit}
            typeData={typeDataEdit}
            reportGrade={reportGradeHoraria}
            studentActivity={studentReport}
        />
    );

    const selectData = (
        <ModalSelectData
            open={openModalSelectData}
            data={word}
            onClose={handleCloseModalSelectData}
            arrItems={handleItemsUpdate}
            dateItem={handleDateItems}
            verifyDate={singleDate}
            editItems={editReport}
            reportGrade={reportGradeHoraria}
            studentActivity={studentReport}
        />
    );

    const falseOption = studentReport ? "Inativo" : "Não";
    const trueOption = studentReport ? "Ativo" : "Sim";

    const reportList = objectReportItems.map((item: any, index: number) => (
        <StyledGridDiv key={item.id}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                }}
            >
                <StyledModalText style={{ margin: 0 }}>
                    {item.nome}
                </StyledModalText>
                {item.obrigatorio && (
                    <p style={{ fontSize: 10, margin: 0 }}>Obrigatório</p>
                )}
            </div>
            {item.isSelected ? (
                <div>
                    <StyledIconModalButton
                        onClick={() => {
                            setEditReport(!editReport);
                            handleEditItems(item, index, item.tipo);
                        }}
                    >
                        <StyledFlexDiv>
                            <StyledModalAction>Editar</StyledModalAction>
                            <IconEdit style={{ margin: "2px 20px 0 0" }} />
                        </StyledFlexDiv>
                    </StyledIconModalButton>
                    <StyledIconModalButton
                        onClick={() => handleDeleteItems(item, index)}
                    >
                        <StyledFlexDiv>
                            <StyledModalAction>Excluir</StyledModalAction>
                            <IconDelete style={{ marginTop: "2px" }} />
                        </StyledFlexDiv>
                    </StyledIconModalButton>
                </div>
            ) : (
                <div>
                    {item.tipo === "BOOLEAN" ? (
                        <StyledSelect
                            onChange={(e) =>
                                handleSelectChange(item.nome, e.target.value)
                            }
                        >
                            <StyledOption>Selecione:</StyledOption>
                            <StyledOption>{falseOption}</StyledOption>
                            <StyledOption>{trueOption}</StyledOption>
                        </StyledSelect>
                    ) : (
                        <StyledIconModalButton
                            onClick={() =>
                                handleOpenModalSelectData(item.nome, index)
                            }
                        >
                            <StyledFlexDiv>
                                <StyledModalAction>Incluir</StyledModalAction>
                                <AddIcon style={{ marginTop: "2px" }} />
                            </StyledFlexDiv>
                        </StyledIconModalButton>
                    )}
                </div>
            )}
        </StyledGridDiv>
    ));

    const dialogClass = `${showDialog ? "visible-dialog" : "hidden-dialog"}`;

    return (
        <Dialog
            openModal={open}
            onHide={onClose}
            className={dialogClass}
            size="400px"
        >
            <StyledModalTitle>Gerar {titleItem}</StyledModalTitle>
            {parameters.length > 0 && (
                <StyledModalSubTitle>
                    Você pode utilizar os filtros abaixo ou gerar o relatório
                    padrão
                </StyledModalSubTitle>
            )}
            <div>{reportList}</div>
            <StyledContainerBtns style={{ gap: 10, marginTop: 20 }}>
                <BtnPrimary
                    type="button"
                    disabled={
                        titleItem !== titleReportPermission &&
                        titleItem !== titleActivityProfessor &&
                        titleItem !== titleProfCoordinator &&
                        !dateRequired
                    }
                    onClick={() => {
                        handleSubmit();
                    }}
                >
                    Gerar Relatório
                </BtnPrimary>
                <DefaultButtonLink onClick={onClose}>
                    Cancelar
                </DefaultButtonLink>
            </StyledContainerBtns>
            {editReport
                ? openModalSelectData && editData
                : openModalSelectData && selectData}
            {dialogMessage}
        </Dialog>
    );
};

export default ModalGenerateReport;
